export const GET_BUSINESS = "GET_BUSINESS"
export const GET_BUSINESS_SUCCESS = "GET_BUSINESS_SUCCESS"
export const ADD_BUSINESS = "ADD_BUSINESS"
export const ADD_BUSINESS_SUCCESS = "ADD_BUSINESS_SUCCESS"

export const PATCH_BUSINESS_GOVERNANCE_RIGHTS = "PATCH_BUSINESS_GOVERNANCE_RIGHTS"
export const PATCH_BUSINESS_GOVERNANCE_RIGHTS_SUCCESS = "PATCH_BUSINESS_GOVERNANCE_RIGHTS_SUCCESS"

export const PATCH_BUSINESS_AS_ADMIN_ACTION = "PATCH_BUSINESS_AS_ADMIN_ACTION"

export const PATCH_USER_ACTIVATION = "PATCH_USER_ACTIVATION"

export const ADMIN_PATCH_BUSINESS_ROLE = "ADMIN_PATCH_BUSINESS_ROLE"
export const ADMIN_DELETE_BUSINESS_ROLE = "ADMIN_DELETE_BUSINESS_ROLE"

export const GET_APP_SETTINGS = "GET_APP_SETTINGS"
export const GET_APP_SETTINGS_SUCCESS = "GET_APP_SETTINGS_SUCCESS"
